<template>
  <a-spin :spinning="spinning" tip="加载中...">
    <div class="top-title" @click="lastStep"><a-icon type="left" /> 近一年维保记录</div>
    <div class="card-value-class" v-if="maintainList.length > 0">
      <a-row :gutter="[0, 15]" v-infinite-scroll="handleInfiniteOnLoadelec"
             :infinite-scroll-disabled="busyelec"
             :infinite-scroll-distance="10"
             :style="{ maxHeight: tableHeight }"
              style="overflow: auto">
        <a-col :span="24" v-for="item in maintainList" :key="item.id">
          <div class="all-card" @click="gotoMiantain(item.id)">
            <a-card :bordered="false">
              <div class="m-list">
                <div class="m-list-col">
                  <a-row :gutter="[0, 10]">
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1 title-div-class">
                          <span v-if="item.type == 1">半月保</span>
                          <span v-if="item.type == 2">季度保</span>
                          <span v-if="item.type == 3">半年保</span>
                          <span v-if="item.type == 4">年度保</span>
                        </div>
                        <div class="div2">
                          <span>{{ formatDate(item.beginTime) }}</span>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">维保单位</div>
                        <div class="div2">
                          {{ item.maintainerOrgName }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">维保人员</div>
                        <div class="div2">
                          {{ item.maintainerName }}
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-card>
          </div>
        </a-col>
      </a-row>
    </div>
    <div  v-else style="margin: 50% auto">
      <a-empty >
        <span slot="description" class="div1"> 近一年暂无维保记录 </span>
      </a-empty>
    </div>
  </a-spin>
</template>

<script>
import axios from "axios";
import infiniteScroll from './directive'
export default {
  components: {},
  directives: { infiniteScroll },
  data() {
    return {
      tableHeight: window.innerHeight - 100 + 'px',
      record:{},
      maintainCount:0,
      elevatorId:null,
      modalForm: {},
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '80', '100']
      },
      spinning:false,
      busyelec: true,
      busydayaelec: [],
      maintainList:[]
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        // 这里处理 query 参数变化的逻辑
        this.record = JSON.parse(newQuery.record)
      }
    }
  },
  created() {
    this.record = JSON.parse(this.$route.query.record)
    this.getMiantainList()
  },
  methods: {
    handleInfiniteOnLoadelec() {
      if (this.busydayaelec.length == 0) {
        this.busyelec = true
        return
      }
      this.pagination.current += 1
      this.getMiantainList()
    },
    getMiantainList(){
      let _this = this
      _this.spinning = true
      let params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        elevId: this.record.id
      }
      axios.get(site.apiHost + "/elevator-public/maint/page-by-elev-id", { params }).then(res => {
        if (res.data.errorCode == 0) {
          if (res.data.data.list.length == 0) {
            this.busyelec = true
            this.busydayaelec = []
            return false
          }
          _this.maintainList = _this.maintainList.concat(res.data.data.list)
          _this.busydayaelec = res.data.data.list
        }
      }).catch(error => {}).finally(()=>{
        this.busyelec = true
        this.spinning = false
      })
    },
    gotoMiantain(id){
      this.$router.push({ path: 'maintainDetail', query: { id: id } });
    },
    lastStep(){
      this.$router.back(-1); // 后退到上一页
    },
    addressOrNumm(value){
      if (value) {
        return value
      } else {
        return ''
      }
    },
    // 时间戳转换
    formatDate(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return y + '-' + this.addZero(m) + '-' + this.addZero(d) + ' ' + this.addZero(h) + ':' + this
        .addZero(mm) + ':' + this.addZero(s);
    },
    formatDate2(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return y + '-' + this.addZero(m) + '-' + this.addZero(d);
    },
    addZero(num) {
      if (num < 10) return '0' + num;
      return num;
    },
  }
};
</script>

<style lang="less" scoped>
.m-list {
  width: 100%;
  height: auto;
}

.m-list-col {
  width: 100%;
}

.m-list-con {
  color: #333333;
  display: flex;
}

.div1 {
  font-size: 14px;
  font-weight: 400;
  flex-shrink: 0;
  color: #999999;
}
.div2 {
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  color: #000000;
  padding-left:15px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-div {
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
}
/deep/ .ant-card {
  border-radius: 10px;
}
/deep/ .ant-card-body {
  padding: 15px;
  zoom: 1;
}

.all-card{
  background: #FFFFFF;
  border-radius: 10px;
}
.top-title{
  background: #ff4d4f;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #ffffff;
  padding: 0 10px;
  margin-bottom: 15px;
  cursor: pointer;
}
.card-value-class{
  margin: 0px 15px;
}
.title-div-class{
  font-size: 16px;
  color: #333333;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/maintainRecord.vue